// ============================================
// API 配置
// ============================================

// 根据环境判断 API 基础地址
const isDev = process.env.NODE_ENV === 'development'

export const API_BASE_URL = isDev 
  ? '/api'  // 开发环境使用代理
  : 'https://cfwork01.yangfeng88.top/api'
